import { __extends } from "tslib";
import React from 'react';
import styles from './InputButtons.scss';
import { Tooltip } from 'wix-style-react';
import { AppMode } from '../../constants/app-mode';
import withAppMode from '../../providers/appMode/withAppMode';
import classNames from 'classnames';
export default withAppMode(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderButton = function (button, i) {
            var _a;
            var isDisabled = button.disabled || _this.props.disabled;
            return (React.createElement("button", { key: i, onClick: function () { return !isDisabled && button.onClick && button.onClick(); }, disabled: isDisabled, "data-hook": button.dataHook, className: classNames(styles.inputButton, button.className, (_a = {},
                    _a[styles.disabled] = isDisabled,
                    _a)), "aria-label": button.ariaLabel }, button.children));
        };
        return _this;
    }
    class_1.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, buttons = _b.buttons, appMode = _b.appMode;
        var fullApp = appMode === AppMode.FullApp;
        return (React.createElement("div", { className: classNames(styles.inputButtons, (_a = {},
                _a[styles.fullApp] = fullApp,
                _a)), "data-hook": "input-buttons" }, buttons &&
            buttons.map(function (button, i) {
                if (button.hide) {
                    return null;
                }
                return button.tooltipContent ? (React.createElement(Tooltip, { key: "button-tooltip" + i, dataHook: button.dataHook + "-tooltip", content: button.tooltipContent, textAlign: "center" },
                    React.createElement("div", null, _this.renderButton(button, i)))) : (_this.renderButton(button, i));
            })));
    };
    return class_1;
}(React.Component)));
//# sourceMappingURL=InputButtons.js.map